import {ErrorHandler, Injectable, NgModule} from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Router,ActivatedRoute } from '@angular/router';
import { ConstantConfigService } from '../services/constant-config.service';
import { DataService } from '../services/data.service';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/do';
import { BehaviorSubject } from 'rxjs';
import { EmailTemplateComponent } from '../pages/email-template/email-template.component';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CookieService } from 'ngx-cookie-service';
const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
	_baseURL : string;
	_imageURL : string;
  _accessToken : string;
  _apiToken : string;
  actiontype : string;

  private messageSource = new BehaviorSubject('none');
  currentMessage = this.messageSource.asObservable();


  constructor(
			private http: HttpClient,
			private router: Router,
      private route: ActivatedRoute,
      public jwtHelper: JwtHelperService,
      public dataService: DataService,
      private cookieService: CookieService
		) {

			this._baseURL = ConstantConfigService.baseURL;
			this._imageURL = ConstantConfigService.ImageUrl;
      this._accessToken = ConstantConfigService.accessToken;
      this._apiToken = ConstantConfigService.apiToken;
      this._AngularUrl = ConstantConfigService.AngularUrl;

      }

      public tokenExpired() {
        const token = localStorage.getItem(this._accessToken);
        if(typeof token !='undefined' && token != null && token != ''){
          console.log('token is',token);
          const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
          console.log('expiry is',expiry);
          return (Math.floor((new Date).getTime() / 1000)) >= expiry;
        } else {
          return true;
        }

      }

      public isAuthenticated(): boolean {
        const token = localStorage.getItem(this._accessToken);
        // Check whether the token is expired and return
		    // true or false
        //console.log("token in authentication is ==========================",token);
        if(typeof token!="undefined" && token!="undefined"  && token!="" && token!=null){
          return !this.jwtHelper.isTokenExpired(token);
        } else {
          return false;
        }

      }

      public getCompanyPlanStatus() {
        const myToken = localStorage.getItem(this._accessToken);
        if(typeof myToken !='undefined' && myToken != null && myToken != ''){
          let decodedToken = helper.decodeToken(myToken);
          let company_id =   decodedToken.userdata.company_id;
          let user_type =   decodedToken.userdata.user_type;
          if(typeof user_type !='undefined' && user_type == 1){
            let plan_payment_status = decodedToken['userdata']['plan_payment_status'];
            return plan_payment_status;
          } else {
            return 0;
          }

        }
      }


      /*public isMaintenanceModeNew(): boolean {


        this.dataService.getMaintenanceModeSettings().subscribe(
          data=>{
            if(data['success']==true){

              if(data['message']['maintenance_mode_status'] == 1){
                console.log('mode is on ',data);
                return true;
              } else {
                console.log('mode is off ',data);
                return false;
              }
            }
            else{
              return false;
            }
          },
          error=>{

          }
        )
      }*/

      isMaintenanceMode(){
        return this.http.get(this._baseURL+'/get-maintenance-mode');
      }


    logFrontEndError(error: any){

      var fullRoute = this.router.url;
      // Here you can provide whatever logging you want
      let errormessage = '';
      let errorstack = '';
      if (error instanceof TypeError) {
        errormessage += 'There was a Type error. '+ error.message;
        errorstack += error.stack;
      } else if (error instanceof Error) {
        errormessage += 'There was a general error. '+ error.message;
        errorstack += error.stack;
      } else {
          errormessage += 'some error happened!'+ error.message;
          errorstack += error.stack;
      }

      console.log('errormessage',errormessage);
      console.log('errorstack',errorstack);
      console.log('fullRoute',fullRoute);
      return this.http.post(this._baseURL+"/log-frontend-error",{"path":fullRoute,"message":errormessage,"stack":errorstack});

    }

    changeMessage(message: string) {
    	this.messageSource.next(message)
  	}

  	//staging_url = this._baseURL;

  	checkUserExist(email,documentkitid,islogin,userid){
  		  return this.http.post(this._baseURL+"/checkemailexistslogin",{"documentkitid":documentkitid,"email":email,"islogin":islogin,"userid":userid}).pipe(
			retry(0),
			catchError(this.handleError)
		);
  	}

	// For Google verify service
	passwordToken(email){
  		return this.http.get(this._baseURL+"/password/token/"+email);
  	}

	// get hash passwords
	getUserPasswordHashed(hash,type=0){
  		return this.http.post(this._baseURL+"/verify-user-password-hash",{"hash":hash,"type":type});
  	}

	getPasswordSettingsForRegister(){
		return this.http.get(this._baseURL+"/password-policy-settings");
	}

	// Change Password
	changePasswordRegular(token,password,type=0){
		return this.http.post(this._baseURL+"/change-password",{'password' :password,'token':token,'password_confirmation':password,'type':type});
	}


	// For Google verify service
	alreadyVerifyGoogle(email,google_opt){
  		  return this.http.post(this._baseURL+"/alreadyVerifyGoogle",{'google_opt' :google_opt.replace(/ /g, ''),"email":email});
  	}


	// For SMS verify service
	verifyOtpLogin(tempstorenumber,sms_opt,verify_phone,email){
  		  return this.http.post(this._baseURL+"/smsOtpVerifyLogin",{'phone' :tempstorenumber,'sms_opt' :sms_opt.replace(/ /g, ''),'verify_phone':verify_phone,'email':email});
  	}

  verifyMagicOtpLogin(sms_opt,email){
    return this.http.post(this._baseURL+"/verify-magic-code",{'email_opt' :sms_opt.replace(/ /g, ''),'email':email});
  }

	verifyGoogleOtp(google_opt,google_secret,email,company_id){
  		  return this.http.post(this._baseURL+"/verifyOtp",{'google_opt' :google_opt.replace(/ /g, ''),'google_secret':google_secret,'email':email,'company_id':company_id});
  	}

	sendTwoFactorScreenGoogleOtp(email){
  		  return this.http.post(this._baseURL+"/getTwofactorScreenGoogle",{'email':email});
  	}

	sendTwoFactorScreenSmsUpdated(email,company_id,role_id,is_individual){
  		  return this.http.post(this._baseURL+"/getTwofactorScreenSMSUpdated",{"email":email,"company_id":company_id,"role_id":role_id,"is_individual":is_individual});
  	}

	authModeTFA(user_id,company_id){
  		  return this.http.post(this._baseURL+"/getDefaultTwoFactorAuthOptionsByCompanyId",{"user_id":user_id,"company_id":company_id});
  	}

  	login(email,is_individual,password){

  		return this.http.post(this._baseURL+"/check-credentials",{"email":email,"is_individual":is_individual,"password":password});

 	  }



//     authenticate(email,is_individual,password,role_id,company_id, is_free){
//   		return this.http.post(this._baseURL+"/services/authenticate/"+is_free,
// 		  {"email":email,"password":password,"is_individual":is_individual,"role_id":role_id,"company_id":company_id}
// 		  );
//   	}

//     uploadCut(company_id,doc_file){
//   		return this.http.post(this._baseURL+"/company/"+company_id+"/template/uploadCutimageBackground",{"document_file":doc_file});
//   	}

//     getPdfNoOfpages(company_id,doc_file,doc_id){
//   		return this.http.post(this._baseURL+"/company/"+company_id+"/template/getPdfNoOfpages",{"document_file":doc_file,"document_id":doc_id});
//   	}

//     store(company_id,postData){
//   		return this.http.post(this._baseURL+"/company/"+company_id+"/template/store",postData);
// =======
// 	  }

     authenticate(email,is_individual,password,role_id,company_id,freeFlow,step,comtype){

  	 	return this.http.post(this._baseURL+"/services/authenticate/"+freeFlow,
	 	  {"email":email,"password":password,"is_individual":is_individual,"role_id":role_id,"company_id":company_id,"step":step,"comtype":comtype}
	 	  );
  	 }

     authenticatefreeflow(email,is_individual,password,role_id,company_id,freeFlow,step,comtype,sender_email,company_id_free_flow){

      return this.http.post(this._baseURL+"/services/authenticate/"+freeFlow,
      {"email":email,"password":password,"is_individual":is_individual,"role_id":role_id,"company_id":company_id,"step":step,"comtype":comtype,'senderemail':sender_email,"cid":company_id_free_flow}
      );
    }

     notifyadminaboutTfaBlock(email,role_id,company_id){
      return this.http.post(this._baseURL+"/raiseSupportTicketToAdmin",{"email":email,"role_id":role_id,"company_id":company_id}
      );
    }

    notifyadminaboutProcessBlock(data){
      return this.http.post(this._baseURL+"/raiseSupportTicketToAdminAboutProcess", data);
    }

    uploadCut(company_id,doc_file){
  		return this.http.post(this._baseURL+"/company/template/uploadCutimageBackground/"+company_id,{"document_file":doc_file});
  	}

    getPdfNoOfpages(company_id,doc_file,doc_id){
  		return this.http.post(this._baseURL+"/company/template/getPdfNoOfpages/"+company_id,{"document_file":doc_file,"document_id":doc_id});
  	}

    store(company_id,postData){
  		return this.http.post(this._baseURL+"/company/template/store/"+company_id,postData);
  	}
    _AngularUrl;
  	logout(){
         // remove user from local storage to log user out
        localStorage.removeItem(this._accessToken);
        this.cookieService.delete(this._accessToken);
        localStorage.removeItem(this._apiToken);
        this.deleteExtraCookies();
        this.router.navigate(['/login']);
        // let link = this._AngularUrl+'login/';
        // this.router.navigate([]).then(result => {  window.open(link); });
    }

    deleteExtraCookies(){
      this.cookieService.set('free_action_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('company_user_login','',{secure:true, sameSite: 'None'});
      this.cookieService.set('secured_token','',{secure:true, sameSite: 'None'});
      this.cookieService.set('is_paid_user','',{secure:true, sameSite: 'None'});
      this.cookieService.set('free_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('company_id_quick_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('sender_email_quick_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('source_location','',{secure:true, sameSite: 'None'});
      this.cookieService.set('action_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('action_type_quick_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('deal_company_id_quick_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('deal_id_quick_flow','',{secure:true, sameSite: 'None'});
      this.cookieService.set('guest_token','',{secure:true, sameSite: 'None'});
      this.cookieService.set('urltimestamp','',{secure:true, sameSite: 'None'});
      this.cookieService.set('water_mark_email','',{secure:true, sameSite: 'None'});
      this.cookieService.set('water_mark_company_id','',{secure:true, sameSite: 'None'});
      this.cookieService.set('water_mark_deal_id','',{secure:true, sameSite: 'None'});
      this.cookieService.set(this._accessToken,'',{secure:true, sameSite: 'None'});

      // Delete
      this.cookieService.delete('free_action_flow');
      this.cookieService.delete('company_user_login');
      this.cookieService.delete('secured_token');
      this.cookieService.delete('is_paid_user');
      this.cookieService.delete('free_flow');
      this.cookieService.delete('company_id_quick_flow');
      this.cookieService.delete('sender_email_quick_flow');
      this.cookieService.delete('source_location');
      this.cookieService.delete('action_flow');
      this.cookieService.delete('action_type_quick_flow');
      this.cookieService.delete('deal_company_id_quick_flow');
      this.cookieService.delete('deal_id_quick_flow');
      this.cookieService.delete('guest_token');
      this.cookieService.delete('urltimestamp');
      this.cookieService.delete('water_mark_emai');
      this.cookieService.delete('water_mark_company_id');
      this.cookieService.delete('water_mark_deal_id');
    }

	handleError(error) {

		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// client-side error
			errorMessage = "Error:" + error.error.message;
		} else {
			// server-side error
			errorMessage = "Error Code:"+error.status+"\nMessage: "+error.message+" Error "+error.error;
		}
		//window.alert(errorMessage);
		return throwError(errorMessage);
	}

	sendForgotEmail(email){
		return this.http.post(this._baseURL+'/password/email', {'email' :email});
	}

  sendMagicCodeToEmail(email){
		return this.http.post(this._baseURL+'/send-magic-code-to-email', {'email' :email});
	}

	getUserInfoFromToken(token,type,limitedinfo){
		return this.http.post(this._baseURL+'/get-user-info', {'token' :token,"type":type ,"limitedinfo":limitedinfo});
	}

	getUserCompanyRole(user_company_id){
		return this.http.get(this._baseURL+"/get-user-role/"+user_company_id);
	}

	authenticate_switch(post){
		return this.http.post(this._baseURL+"/authenticate",post);
  }

  gettopNotifications(email,company_id,role_id,user_id,top){
    return this.http.post(this._baseURL+"/getnotificationsforuser",
    {"email":email,"role_id":role_id,"company_id":company_id,"user_id":user_id,"top":top}
    );
  }

  markNotificationAsRead(email,company_id,role_id,user_id,top){
    return this.http.post(this._baseURL+"/marknotificationasread",
    {"email":email,"role_id":role_id,"company_id":company_id,"user_id":user_id,"top":top,'action':'markasread'}
    );
  }

  checkUserInfo(company_key,company_secret,login_token){
    return this.http.post(this._baseURL+"/checkHubSpotUserInfo",{"company_key":company_key,"company_secret":company_secret,"login_token":login_token,'action':'userdevinfo'});
  }

  checkUserInfoNew(postData){
    return this.http.post(this._baseURL+"/checkHubSpotUserInfo",postData);
  }


}
